<template>
	<el-aside>
		<div class="logo">
			<a class="noline" href="/#/">
				<img class="sbklogo" src="../../../assets/images/sbklogo2.png" alt="">
				<img class="sbktext" src="../../../assets/images/sbktext2.png" alt="">
			</a>
			<div style="font-size: 12px;" v-if="hospitalCode == 'SD_LY1'">临沂市中心医院</div>
			<div style="font-size: 12px;font-weight:bold;color:#6a9ce3" v-if="hospitalCode == 'SD_TA2'">泰安市中心医院</div>

		</div>
		<SiteMenu :menu="menu" :menuActive="menuActive" @select="onMenuSelect"></SiteMenu>
	</el-aside>
</template>

<script>
import api from '@/service/api.js';
import SiteMenu from './components/SiteMenu';

export default {
	components: { SiteMenu },
	data() {
		return {
			menuActive: '',
			menuList: '',
			menu: undefined,
			hospitalCode: 'YS_HM4',

		}
	},
	watch: {
		// 监听路由对象中的变化
		'$route'(to, from) {
			this.routeHandle()
		}
	},
	async created() {
		let res = await api.getMyMenu();
		this.menu = res.data;
		this.menu.forEach(item => {
			// 方便循环时作判断
			item.parentId = 0;
		});
		this.hospitalCode = await api.getHospitalCode();
		this.routeHandle()
	},
	methods: {
		async routeHandle() {
			const currentRouteName = this.$route.name;
			// 根据当前路由名称找到对应的菜单项ID
			const menuItem = this.findMenuItemByRouteName(this.menu, currentRouteName);
			if (menuItem) {
				this.menuActive = menuItem.id.toString();

				// console.log('设置菜单高亮:', this.menuActive);
			} else {
				console.log('未找到匹配的菜单项');
			}
		},
		async onMenuSelect(menuId) {
			const selectMenu = this.findMenuItemById(this.menu, menuId).data;
			const params = selectMenu.menuParams != "" ? JSON.parse(selectMenu.menuParams) : null;
			if (params != null && params.target == "_blank") {
				let routerJump = this.$router.resolve({ name: selectMenu.menuUrl, query: params });
				window.open(routerJump.href, '_blank');
			} else {
				this.$router.push({ name: selectMenu.menuUrl, query: params });
			}
		},
		update() {

		},
		// 使用递归函数查找匹配的对象
		findMenuItemById(menu, targetId) {
			for (const item of menu) {
				if (item.id == targetId) {
					return item; // 找到匹配的对象
				} else if (item.children && item.children.length > 0) {
					const result = this.findMenuItemById(item.children, targetId);
					if (result) {
						return result; // 在子菜单中找到匹配的对象
					}
				}
			}
			return null; // 未找到匹配的对象
		},
		// 根据路由名称和参数查找菜单项
		findMenuItemByRouteName(menu, routeName) {
			if (!menu || !routeName) return null;

			const currentQuery = this.$route.query || {};
			let bestMatch = null;
			let bestMatchScore = -1;

			for (const item of menu) {
				// 检查当前菜单项的 menuUrl 是否匹配路由名称
				// 兼容两种数据结构：直接在 item 上或在 item.data 中
				const menuUrl = item.menuUrl || (item.data && item.data.menuUrl);

				if (menuUrl === routeName) {
					// 解析菜单参数
					const menuParams = item.menuParams || (item.data && item.data.menuParams) || "";
					let menuQuery = {};

					if (menuParams) {
						try {
							menuQuery = JSON.parse(menuParams);
						} catch (e) {
							console.warn('菜单参数解析失败:', menuParams);
						}
					}

					// 计算匹配度
					const matchScore = this.calculateQueryMatchScore(currentQuery, menuQuery);

					if (matchScore > bestMatchScore) {
						bestMatch = item;
						bestMatchScore = matchScore;
					}
				}

				// 递归查找子菜单
				if (item.children && item.children.length > 0) {
					const result = this.findMenuItemByRouteName(item.children, routeName);
					if (result) {
						// 如果子菜单找到了更好的匹配，比较匹配度
						const childMenuParams = result.menuParams || (result.data && result.data.menuParams) || "";
						let childMenuQuery = {};

						if (childMenuParams) {
							try {
								childMenuQuery = JSON.parse(childMenuParams);
							} catch (e) {
								console.warn('子菜单参数解析失败:', childMenuParams);
							}
						}

						const childMatchScore = this.calculateQueryMatchScore(currentQuery, childMenuQuery);

						if (childMatchScore > bestMatchScore) {
							bestMatch = result;
							bestMatchScore = childMatchScore;
						}
					}
				}
			}

			return bestMatch;
		},

		// 计算查询参数匹配度
		calculateQueryMatchScore(currentQuery, menuQuery) {
			if (!menuQuery || Object.keys(menuQuery).length === 0) {
				// 如果菜单没有参数，但当前路由有参数，匹配度较低
				return Object.keys(currentQuery).length === 0 ? 1 : 0.5;
			}

			let matchCount = 0;
			let totalMenuParams = Object.keys(menuQuery).length;

			for (const [key, value] of Object.entries(menuQuery)) {
				if (currentQuery[key] && currentQuery[key].toString() === value.toString()) {
					matchCount++;
				}
			}

			// 完全匹配得分最高，部分匹配得分较低
			return totalMenuParams > 0 ? (matchCount / totalMenuParams) * 2 : 0;
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

.sbklogo {
	width: 25px;
	height: 25px;
}

.sbktext {
	margin-left: 8px;
	width: 116px;
	height: 13px;
}

.el-aside {
	position: fixed;
	width: 250px !important;
	overflow-x: hidden;
	overflow-y: auto;
	z-index: 1;
}

.el-menu {
	border: none;

	i {
		top: -1px;
		margin-right: 10px;
	}

	.el-submenu {
		.el-menu-item {
			padding-left: 50px !important;
		}

		.el-submenu {
			.el-menu-item {
				padding-left: 70px !important;
			}
		}
	}
}

.logo {
	width: 100%;
	height: 60px;
	margin-bottom: 20px;
	border-bottom: 1px solid #e6e6e6;
	text-align: center;

	a {
		height: 40px;
		background-size: 30px 35px;
		color: @fckey;
		text-decoration: none;
		justify-content: center;
		align-items: center;
		display: flex;
	}

	i {
		margin-right: 4px;
		font-size: 30px;
	}
}
</style>
